// removed by extract-text-webpack-plugin
module.exports = {"guide":"_1hUL","right":"_4NTn","left":"_3_MK","qr":"_1zTh","up":"_26w4","down":"shik","space":"_2rSr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/guide/index.less
// module id = 313
// module chunks = 0